import { network } from 'services/network';

export const setShowPredictionLikelihood = (params: QueryParams): Promise<QueryResponse> => {
    const url = `api/bo/setActivityPredictionPercentageViewStatus`;
    return network.post(url, params).then((response) => response.data);
};

export interface QueryParams {
    status: boolean;
    projectId: number;
}

export interface QueryResponse {
    projectId: string;
    showPredictionLikelihood: boolean;
}
